import _ from 'lodash'
import { useEffect } from 'react'
import useMixPanelTracking from '../MixpanelIntegration'

function useSetMixpanelUser(userData) {
  const mixPanel = useMixPanelTracking()
  useEffect(() => {
    if (!_.isEmpty(userData)) {
      const emailId = _.get(userData, ['email'])
      mixPanel.identify(emailId)
      const peopleObject = { ...userData }
      mixPanel.set_people(peopleObject)
    }
  }, [userData])
}

export default useSetMixpanelUser
